//core
import React, { useEffect } from "react";
import { useFormikContext, Field } from "formik";
// @ts-ignore
import Big from "big.js"

//hooks
import useDidMountEffect from "../../../../../../customHooks/useDidMountEffect";
import { useFields } from "../../../../../../store/common/fields/useFields";


interface IHelperField {
  values: any;
}

const HelperField = (props:IHelperField) => {
  const { values } = props;

  const {
    setFieldValue,
  } = useFormikContext();
	const { clearTrackers } = useFields();

	useDidMountEffect(() => {
		clearTrackers();
		setFieldValue('trackerId', '');
	}, [values.affiliateId]);

  return (
    <>
      <Field hidden />
    </>
  );
};

export default HelperField;
